<!-- eslint-disable max-len -->
    <template>
  <div class="py-1">
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="modalOpen"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                {{ mssg }}
              </div>
              <svg
                v-if="failedDmlist.length"
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="modalOpen = false"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <div
              v-if="failedDmlist.length"
              class="text-gray-900 font-bold text-lg"
            >
              Failed for {{ failedDmlist.length }}
            </div>
            <div v-for="(student, index) in failedDmlist" :key="index">
              <div class="text-gray-900">{{ student.userName }}</div>
            </div>
            <hr v-if="failedDmlist.length" class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="callback">Done</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ResponseMessage',
  layout: 'admin',
  props: ['openPopup', 'callback', 'mssg', 'failedDmlist'],
  data() {
    return {
      modalOpen: this.openPopup, // please check it
    };
  },
  watch: {
    openPopup() {
      this.modalOpen = this.openPopup;
    },
  },
  methods: {},
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
